export default function FlagIcon24({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.9314 11.5000C21.8457 11.3480 21.8007 11.1755 21.8007 11.0000C21.8007 10.8245 21.8457 10.6520 21.9314 10.5000L23.6082 7.5000C23.8650 7.0438 24.0001 6.5263 24.0000 5.9995C23.9999 5.4727 23.8646 4.9553 23.6077 4.4992C23.3508 4.0431 22.9813 3.6644 22.5365 3.4012C22.0916 3.1380 21.5869 2.9997 21.0733 3.0000H5.4749C5.2163 3.0000 4.9684 3.1054 4.7855 3.2929C4.6027 3.4804 4.5000 3.7348 4.5000 4.0000V26.0000C4.5000 26.2652 4.6027 26.5196 4.7855 26.7071C4.9684 26.8947 5.2163 27.0000 5.4749 27.0000C5.7335 27.0000 5.9814 26.8947 6.1643 26.7071C6.3471 26.5196 6.4498 26.2652 6.4498 26.0000V19.0001H21.0733C21.5856 18.9993 22.0885 18.8607 22.5320 18.5981C22.9755 18.3354 23.3440 17.9580 23.6007 17.5034C23.8574 17.0487 23.9931 16.5330 23.9945 16.0077C23.9956 15.4824 23.8625 14.9659 23.6082 14.5100L21.9314 11.5000Z"
        fill={color ? color : "#6C6969"}
      />
    </svg>
  );
}
